import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import PaymentService from './PaymentService';

import schema from './athleteJsonSchema';
import DirectoryService from 'components/app/directory/DirectoryService';
const jsonSchema = schema;
const mergedJsonSchema = (jsonSchema, optionValues) => {

  const updatedJsonSchema = jsonSchema.map(f => {
    if (f.name === 'membershipPlan') {
      return { ...f, options: optionValues };
    }
    return f;
  });
  return updatedJsonSchema;
};
const AthleteForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [optionValues, setOptionValues] = useState();


  useEffect(() => {
    const fetchData =  async () => {
    const products =  await PaymentService.retrieveAllProductsByAccount();

    const values = products.map(o => ({
        label: o.description, 
        value: o.identifier
      }));

    setOptionValues(values);
    };  
    if (undefined !== identifier) {
      DirectoryService.retrieveProfile(identifier)
        .then(data => {
          const updateData = {
            ...data,
            membershipPlan: {
              label: data.membershipPlan?.description,
              value: data.membershipPlan?.identifier
            }
          };

          setData(updateData);
        })
        .catch(error => console.log(error));
    }
    fetchData();
  }, [identifier]);
  const handleAthleteFormSubmit = formData => {
    PaymentService.saveAthlete(formData)
      .then(response => {
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Athlete',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Athlete');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
      'Create Athlete',
    ' ',
    buttonsConf
  );

  return (
    <>

      {modalShow && (
        <FormModal
          message={'Athlete  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl='/app/wod/settings/payments'
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleAthleteFormSubmit}
              optionValues={optionValues}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, optionValues }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    mergedJsonSchema(jsonSchema, optionValues),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default AthleteForm;
